class promotionBanner extends HTMLElement {
    constructor() {
        super();

        let discount_tags_string = "{{ discount_tags_string }}";
        this.currentPromotionDate = this._getCurrentDate();
        this.blockSettingsPriority = 1000;
        this.htmlElement = null;
        this.excludedForMarket = null;
        this.includedForMarket = null;
        this.blockDateFrom = null;
        this.blockDateTo = null;
        this.blockPriority = 1;

        this.productTemplate = this._isProductTemplate();
        this.collectionTemplate = this._isCollectionTemplate();
        this.elementWrapper = '.promotion-wrapper';
        this.countdownWrapper = '.promotion-container';
        this.countdownDiv = '.promotion-banner-message';
        this.dateFromAttribute = 'data-from-date';
        this.dateToAttribute = 'data-to-date';
        this.priorityAttribute = 'data-priority';
        this.appendRender = '.discount-section--js-render';
        this.galleryContainer  = '.product__wrapper--scrollable';

        var promotionDivs = this.querySelectorAll(this.countdownWrapper);

        var htmlElement = new Promise((resolve, reject) => {
            promotionDivs.forEach((value, index, array) => {
                this.enableBanner(value);
                if (index === array.length -1) resolve();
            });
        });

        htmlElement.then(() => {
            if (this._isProductTemplate()) {
                document.querySelector(this.appendRender).innerHTML = this.htmlElement;
                document.querySelector(this.elementWrapper).style.cssText += 'margin: 0 0 25px;padding: 10px;';
            }
            if (this._isCollectionTemplate() && this.htmlElement != null) {
                this.classList.remove("hidden");
            }
        });

    }

    _isProductTemplate(){
        if (document.querySelector("body.template-product")) return true;
        else return false;
    }

    _isCollectionTemplate(){
        if (document.querySelector("body.template-collection") || document.querySelector("body.template-search")) return true;
        else return false;
    }

    _getCurrentDate() {
        const date = new Date();
        const year = date.toLocaleString('default', {
            timeZone: 'Europe/Rome',
            year: 'numeric'
        });
        const month = date.toLocaleString('default', {
            timeZone: 'Europe/Rome',
            month: '2-digit',
        });
        const day = date.toLocaleString('default', {
            timeZone: 'Europe/Rome',
            day: '2-digit'
        });

        return [year, month, day].join('-');

    }

    enableBanner(promotionDiv){
        var messageDiv = promotionDiv.querySelector(this.countdownDiv);
        var block_date_from = messageDiv.getAttribute(this.dateFromAttribute);
        var block_date_to = messageDiv.getAttribute(this.dateToAttribute);
        var block_priority = messageDiv.getAttribute(this.priorityAttribute);
        if (block_priority < this.blockSettingsPriority && (block_date_to == "" || block_date_to >= this.currentPromotionDate) && (block_date_from == "" || block_date_from <= this.currentPromotionDate)) {
            this.blockSettingsPriority = block_priority;
            this.htmlElement = promotionDiv.innerHTML;
        }
    }
}

customElements.define('promotion-banner', promotionBanner);